import Methods from './Methods';
export default Methods;
